/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateDemoInput = {
    name?: string | null | undefined;
    sharedInCompany?: boolean | null | undefined;
    viewDay?: number | null | undefined;
    viewMonth?: number | null | undefined;
    viewYear?: number | null | undefined;
    anonymize?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createDemoMutationVariables = {
    input: CreateDemoInput;
};
export type createDemoMutationResponse = {
    readonly createDemo: {
        readonly demo: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly trialDemo: boolean | null;
                readonly sharedInCompany: boolean | null;
                readonly createdByEmail: string | null;
                readonly numberOfProjects: number | null;
            } | null;
        } | null;
    } | null;
};
export type createDemoMutation = {
    readonly response: createDemoMutationResponse;
    readonly variables: createDemoMutationVariables;
};



/*
mutation createDemoMutation(
  $input: CreateDemoInput!
) {
  createDemo(input: $input) {
    demo {
      node {
        id
        name
        trialDemo
        sharedInCompany
        createdByEmail
        numberOfProjects
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateDemoInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDemoPayload",
    "kind": "LinkedField",
    "name": "createDemo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DemoTypeEdge",
        "kind": "LinkedField",
        "name": "demo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Demo",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trialDemo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharedInCompany",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdByEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfProjects",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createDemoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createDemoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createDemoMutation",
    "operationKind": "mutation",
    "text": "mutation createDemoMutation(\n  $input: CreateDemoInput!\n) {\n  createDemo(input: $input) {\n    demo {\n      node {\n        id\n        name\n        trialDemo\n        sharedInCompany\n        createdByEmail\n        numberOfProjects\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '90b829304fe42a57446746d863fb3495';
export default node;
